import { useIntl } from "react-intl";

export default function MarketPlace({ step, setStep }) {
  const intl = useIntl();

  const steps = [
    {
      title: intl.formatMessage({ id: "CHECKOUT.ADDRESS" }),
      desc: intl.formatMessage({ id: "CHECKOUT.ADDRESS_DESC" }),
    },
    {
      title: intl.formatMessage({ id: "CHECKOUT.PAYMENT" }),
      desc: intl.formatMessage({ id: "CHECKOUT.PAYMENT_DESC" }),
    },
    {
      title: intl.formatMessage({ id: "CHECKOUT.PURCHASE" }),
      desc: intl.formatMessage({ id: "CHECKOUT.PURCHASE_DESC" }),
    }
  ];

  return (
    <div className="wizard-nav">
      <div className="wizard-steps" data-total-steps="3">
        {steps.map((item, index) => (
          <div
            className="wizard-step" data-wizard-type="step"
            data-wizard-state={step === index + 1 ? "current" : ""}
            key={index}
          >
            <div className="wizard-wrapper">
              <div className="wizard-number">
                {index + 1}
              </div>
              <div className="wizard-label">
                <div className="wizard-title">
                  {item.title}
                </div>
                <div className="wizard-desc">
                  {item.desc}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
